import React from 'react';
import { AmendmentRecord } from '../../types';

interface Props {
  amendments: AmendmentRecord[];
  title?: string;
}

const AmendmentLog: React.FC<Props> = ({ amendments, title = 'Amendment History' }) => {
  if (!amendments || amendments.length === 0) return null;

  const formatDate = (dateStr: string) => {
    const d = new Date(dateStr);
    return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
  };

  return (
    <div className="mt-4">
      <h4 className="text-sm font-semibold text-gray-800 mb-2">{title}</h4>
      <div className="overflow-x-auto rounded-lg border border-gray-200">
        <table className="min-w-full text-xs">
          <thead>
            <tr className="bg-gray-100 text-gray-500 uppercase tracking-wider">
              <th className="px-3 py-2 text-left">Date</th>
              <th className="px-3 py-2 text-left">Field</th>
              <th className="px-3 py-2 text-left">Change</th>
              <th className="px-3 py-2 text-left">Reason</th>
              <th className="px-3 py-2 text-left">By</th>
            </tr>
          </thead>
          <tbody>
            {amendments.map((a, idx) => (
              <tr key={idx} className={idx % 2 === 1 ? 'bg-gray-50' : 'bg-white'}>
                <td className="px-3 py-2 text-gray-400 whitespace-nowrap">
                  {formatDate(a.amendedAt)}
                </td>
                <td className="px-3 py-2 font-medium text-gray-700 whitespace-nowrap">
                  {a.field}
                </td>
                <td className="px-3 py-2">
                  <span className="text-red-500 line-through">{a.previousValue}</span>
                  <span className="mx-1 text-gray-400">&rarr;</span>
                  <span className="text-green-600">{a.newValue}</span>
                </td>
                <td className="px-3 py-2 text-gray-600 italic max-w-xs truncate">
                  {a.reason}
                </td>
                <td className="px-3 py-2 text-gray-700 whitespace-nowrap">
                  {a.amendedByName || a.amendedBy}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AmendmentLog;
